ticket.ticketLotteryModule = {
    // Funkcia sluzi na generovanie tabulky vyhernosti v rozpracovanom tikete pre loteriove hry
    ticketTableLotteryKenoGenerate: function(selectedBallsCount, leagueCupID, bet) {
        if (selectedBallsCount) {

            const spotData = lotteryOffer["league" + String(leagueCupID)].balls[selectedBallsCount];

            if (spotData) {
                const tableHead = `
                <caption>${texts.LotteryWinTableKenoTabel}</caption>
                <thead>
                    <tr>
                        <th class="hits">${texts.LotteryWinTableHits}</th>
                        <th class="pays">${texts.LotteryWinTablePays}</th>
                        <th class="win">${texts.LotteryWinTableEvWin}</th>
                    </tr>
                </thead>
                `;

                const tableBody = Object.keys(spotData)
                    .filter((key) => key.startsWith('hits_'))
                    .map((key) => {
                        const selectedBallsCount = parseInt(key.slice(5));
                        const payoutData = spotData[key];
                        return `
                        <tr>
                            <td class="hits">${selectedBallsCount}</td>
                            <td class="pays"><span class="pill">${parseFloat(payoutData.pays).toFixed(2)}</span></td>
                            <td class="win">${shared.floor2(payoutData.pays * bet, 1) + " " + profile.Currency}</td>
                        </tr>
                    `;
                    })
                .join('');

                return '<table class="ticket-table-lottery">' + tableHead + tableBody + '</table>';

            } else {
                console.error(`No data found for ${selectedBallsCount} selected balls.`);
            }
        } else {
            console.error('Element with ID "keno-table" not found for displaying the table.');
        }

        return '';
    },

    // Funkcia sluzi na toggle zobrazenia tabulky vyhernosti pre loteriove hry v rozpracovanom tikete
    ticketTableLotteryToggle: function(oddID) {
        try {
            var ticketTableLotteryWrapp = $("#ticketList #" + oddID);
            var ticketTableLotteryToggle = $("#ticketList #tableTicketLotteryWrapper" + oddID);
            if (ticketTableLotteryWrapp.hasClass("collapsible-lottery-table-expanded")) {
                // Skryje tabulku vyhernosti
                ticketTableLotteryWrapp.removeClass("collapsible-lottery-table-expanded");
                ticketTableLotteryToggle.addClass("hide");

                list.OddsTicketLotteryExpanded = list.OddsTicketLotteryExpanded.filter(function(oTLE) {
                    return oTLE !== oddID;
                });
            } else {
                // Zobrazi tabulku vyhernosti
                ticketTableLotteryWrapp.addClass("collapsible-lottery-table-expanded");
                ticketTableLotteryToggle.removeClass("hide");

                list.OddsTicketLotteryExpanded.push(oddID);

            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecuje zmeny v UI a potrebny flow pre loteriove hry
    ctRenderCombinationsLottery: function(data, isLottery) {
        try {
            if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) return false;
            $("#depositDial").addClass("calculator-srtl").find(".stake-bet").text(shared.floor2(data.TotalBet, 1)).parent().show();

            var anyPinned = data.OddsCombi.some(function(oc) {
                return oc.Pinned == true;
            });
            // if (anyPinned && stored.BetAll && (data.GrossBet === stored.OverallTotalBet)) {
            if (anyPinned && !stored.BetAll) {
                // Ak je akakolvek kombinacia pinnuta - treba ju odpinovat (unpin all)
                // Zavola sa len vtedy ked je uz dokoncene odomknutie vkladu (koli duplicitnym volaniam)
                ticket.ticketCombiModule.ctUnpinCombination("all", "all", true, true);
            } else if (anyPinned && stored.BetAll && (data.GrossBet !== stored.OverallTotalBet)) {
                // Ak je akakolvek kombinacia pinnuta - treba ju odpinovat (unpin all)
                // Zavola sa len vtedy ked je uz dokoncene odomknutie vkladu (koli duplicitnym volaniam)
                ticket.ticketCombiModule.ctUnpinCombination("all", "all", true, true);
            } else if (isLottery) {
                // Flow: bol zmeneny spell - vklad na 1 kombinaciu - je potrebne nanovo vykreslit tiket koli zmenenym vkladom na jedno-kombinaciu
                ticket.ticket(data, false, true);
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia obsluhuje stlacenie tlacidiel + - v rozrobenom tikete pre loteriove hry
    setSpellLottery: function(spellID, change, value) {
        try {
            if (spellID && change) {
                // Ulozenie vstupu aby nasledne bol vo funkcii ticket.ticketCombiModule.ctUnpinCombination() zvyrazneny v UI ked dobehnu volania na ticketWS
                stored.inputElement = $("#betLottery" + spellID);
                value = shared.floor2(value + change);

                if (value < profile.MinDep) {
                    value = profile.MinDep;
                    if ((odds.length !== 1) || (value < profile.MinDepPerSlip)) {
                        // Nastavi minimalny mozny vklad
                        value = profile.MinDepPerSlip;
                    }
                    modal.showErrObj(2, 5, {err1: texts.TicketErr13 + " " + shared.floor2(value, 1) + " " + profile.Currency, errType: "TicketErr13"});
                }
                ticket.ticketCombiModule.ctSetSpellStake(value, spellID, true, true);
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Pridanie lottery oddu na tiket ROZPRACOVANE
    ctAddOddLottery: function(eventID, leagueCupID, oddData, timestamp) {
        try {
            if (eventID && leagueCupID && oddData && oddData.betType && oddData.value && timestamp) {
                var tip;
                if (Array.isArray(oddData.value)) {
                    tip = oddData.value.join();
                } else {
                    tip = oddData.value;
                }
                modal.showLoading();
                // Zamkne submit tlacitka
                main.lockSbmButtons();
                // Zamkne lottery iframe
                lottery.lockLotteryIframe();
                try {
                    var requestUrl;
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/lotteryadd/" + eventID + "/" + oddData.betType + "/" + tip)
                        .done(function (data) {
                            if (data === Object(data)) {
                                if (data.Errors && !data.Errors.length) {
                                    // Odosle informaciu o pridani oddu do iframe - resetuje vstupy v iframe
                                    lottery.sendDataToIframeLotteryGame({target: String(oddData.betType)}, "inputsReset", null, $("#" + leagueCupID + "Iframe"));
                                }
                                // Nastavi typ tiketu a kalkulacku pre loteriove hry
                                ticket.state.setState({isLotteryTicket: data.IsLotteryTicket, type: data.TYPE});
                                ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));
                                // Vyrendruje tiket
                                ticket.ticket(data, null, true, true);
                            } else {
                                // NO DATA -> TICKET RETRIEVE
                                main.createLog(2, "CentralTicketLotteryRem_Failed", "# ODD: " + oddID);
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicketLotteryRem_Failed", "# ODD: " + oddID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        })
                        .always(function (data) {
                            modal.hideLoading();
                            // Odomkne submit tlacitka
                            main.unlockSbmButtons(true);
                            // Odomkne lottery iframe
                            lottery.unlockLotteryIframe();
                            // Zobrazi pripadne error hlasky
                            if (data) {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});
                            }
                        });
                } catch (e) {
                    modal.hideLoading();
                    // Odomkne submit tlacitka
                    main.unlockSbmButtons(true);
                    // Odomkne lottery iframe
                    lottery.unlockLotteryIframe();
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                }
                // Ak nebezi refresh tiketu tak schova napovedu
                if (!rfs.ticket && list.Odds.length) {
                    $("#ticketHelp").hide();
                    ticket.stopMarkingHelp();
                }
            }
        } catch (e) {
            modal.hideLoading();
            main.createLog(2, "ctAddOddLottery_Failed", "# eventID: " + eventID + " # data: " + JSON.stringify(data) + " # timestamp: " + timestamp);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Odobranie lottery oddu z tiketu ROZPRACOVANE
    ctRemoveOddLottery: function(oddID, eventID, chancetypeID, leagueCupID) {
        try {
            if (event) event.stopImmediatePropagation();
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }

            modal.showLoading();
            // Zamkne submit tlacitka
            main.lockSbmButtons();
            // Zamkne lottery iframe
            lottery.lockLotteryIframe();
            ++list.Sync;
            try {
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/lotteryrem/" + eventID + "/" + chancetypeID)
                    .done(function (data) {
                        if (data === Object(data)) {
                            --list.Sync;
                            if (data.Errors && !data.Errors.length) {
                                // Zmaze odd z listu exspirovanych oddov
                                list.OddsExpired = list.OddsExpired.diff([oddID]);
                                // Zmaze odd z listu
                                ticket.listCheck(oddID, null, "remove");
                                // Aktualizuje zoznam expirovanych oddov
                                list.OddsExpired = list.OddsExpired.interSection(list.Odds);
                                // Aktualizuje zoznam expirovanych oddov ktore boli skryte
                                list.OddsExpiredHidden = list.OddsExpired.interSection(list.OddsExpiredHidden);
                            }
                        } else {
                            // NO DATA -> TICKET RETRIEVE
                            main.createLog(2, "CentralTicketLotteryRem_Failed", "# ODD: " + oddID);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        --list.Sync;
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketLotteryRem_Failed", "# ODD: " + oddID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        ticket.ticketWsRetrieve(true);
                    })
                    .always(function (data) {
                        // Odosle informaciu o pridani oddu do iframe - resetuje vstupy v iframe
                        lottery.sendDataToIframeLotteryGame({target: String(chancetypeID)}, "inputsReset", null, $("#" + leagueCupID + "Iframe"));

                        if (list.Sync === 0) {
                            // Nastavi typ tiketu podla tiketovej sluzby
                            ticket.state.setState({isLotteryTicket: data.IsLotteryTicket});
                            ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));
                            // Vyrendruje tiket
                            ticket.ticket(data, null, true, true);
                            // Zobrazi pripadne error hlask
                            if (data) {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});
                            }
                            // Odomkne submit tlacitka
                            main.unlockSbmButtons();
                            // Odomkne lottery iframe
                            lottery.unlockLotteryIframe();

                            modal.hideLoading();
                        }
                    });
            } catch (e) {
                modal.hideLoading();
                // Odomkne submit tlacitka
                main.unlockSbmButtons();
                // Odomkne lottery iframe
                lottery.unlockLotteryIframe();
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            modal.hideLoading();
            // Odomkne submit tlacitka
            main.unlockSbmButtons();
            // Odomkne lottery iframe
            lottery.unlockLotteryIframe();
            return false;
        }
    },

    // Funkcia na parsovanie a upravu informacii pre zobrazenie ticketu loterie (KENO, Lucky Loot)
    parseLottery: function(odd, ticket) {
        // Pridanie informaci o stavke a vyhre do odd
        var oddResult = ticket?.OddsCombi.find(({ID}) => ID === odd.Group);
        odd.PotWin = oddResult?.PotWin;
        odd.Bet = oddResult?.Bet;

        // default pole pre min a max kurzy z tabulky vyhier pre loterie
        odd.lotteryRates = [];

        // uprava nazvu pre (ne)zobrazenie team
        odd.Team1 = "";

        // nastavenie pre ne/zobrazenie riadka s detailom na onclick
        odd.collapsibleRow = true; // default
        
        // naplnenie chanceType na nazov tipu
        switch (odd.ChanceTypeID) {
            // KENO
            case "uf:5019":
                odd.ChanceType = "Win";
                // osetrenie pola tipov
                var tip = odd.Tip;
                tip = tip.split(",");
                var tableData = lotteryOffer.league624205.balls[tip.length];
                // pridanie min ... max kurz do dat oddu z tabulky KENO
                Object.entries(tableData).forEach(([key, value]) => {
                    odd.lotteryRates.push(value.pays);
                });
                break;

            case "uf:5030":
                odd.ChanceType = "Heads and Tails";
                // nastavenie pre nezobrazenie riadka s detailom na onclick pri nevyhodnotenom H&T
                if (odd.IsWinning == "U") odd.collapsibleRow = false;
                break;

            // Lucky Loot - TODO
            case "uf:5001":
                odd.ChanceType = "Win";
                break;

            default:
                break;
        }

        // oprava LeagueCupName
        if (odd.LCUP == 624204) odd.LeagueCupName = "Lucky Loot";
        
        return odd;
    }
};
